import ITaskFactory from "./ITaskFactory";
import Task from "./Task";
import TaskExecutor from "./TaskExecutor";

export default class TaskFactory extends ITaskFactory {

    /**
     * Factory for creating Task objects and injecting dependencies into them.
     * @param {infuse.Injector} injector - the soma Injector
     */
    constructor(injector) {
        super();
        this._injector = injector;
    }

    /**
     * Instantiates a Task subclass and injects dependencies
     * @param {Function} className - Class to instantiate must extend Task (or implement same methods).
     * @returns {Task} - instantiated task
     */
    instantiateTask(className) {
        const task = this._injector.createInstance(className);
        return task;
    }

}